import { render, staticRenderFns } from "./powerConfig.vue?vue&type=template&id=360a930c&scoped=true"
import script from "./powerConfig.vue?vue&type=script&lang=js"
export * from "./powerConfig.vue?vue&type=script&lang=js"
import style0 from "./powerConfig.vue?vue&type=style&index=0&id=360a930c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360a930c",
  null
  
)

export default component.exports